























import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { ValidationError } from 'class-validator';
import NewTranslation from '@/components/i18n/NewTranslation.vue';

@Component({
  components: { NewTranslation },
})
export default class FormField extends Vue {
  @Prop(String)
  public identifier!: string;

  @Prop(Boolean)
  public disabled!: boolean;

  @Prop({ type: Boolean, default: true })
  public labelIsPath!: boolean;

  @Prop(Boolean)
  public hasInfo!: boolean;

  @Prop(Boolean)
  public isMandatory!: boolean;

  @Prop(String)
  public label!: string;

  @Prop(Object)
  public validationError!: ValidationError | null;

  @Prop(Array)
  public warnings!: string[] | null;

  public get hasWarnings(): boolean {
    return this.warnings ? this.warnings.length > 0 : false;
  }

  @Emit()
  public infoClick(): void {}
}
